<div class="detail-page">
  <div class="otsake-container">
    <button class="sulje light-blue-text" mat-button (click)="peruuta()" type="button">
      <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
    </button>

    <div class="otsake">
      <div>
        <span>{{ 'kuitit.katsele.tosite' | translate | async }}</span>
        <h2 class="light-blue-text">{{ otsakeObservable | async }}</h2>
      </div>
      <!-- <div *ngIf="naytaTavallinenOtsake()">
      <span>{{'lasku.katsele-muokattava-dialog.lasku' | translate | async}}</span>
      <h2 class="light-blue-text">{{laskuSharedService.annaMuotoiltuLaskunumero(kasiteltava)}} {{kasiteltava?.asiakas?.nimi}}</h2>
    </div>
    <div *ngIf="naytaMaksuaikaa()">
      <span>{{'lasku.katsele-muokattava-dialog.maksuaikaa' | translate | async}}</span>
      <h2 [class.light-blue-text]="annaMaksuaikaa() > -1" [class.red-text]="annaMaksuaikaa() < 0">{{annaMaksuaikaa()}} pv</h2>
    </div> -->
      @if (showSumma()) {
        <div>
          <span>{{ 'kuitit.katsele.summa' | translate | async }}</span>
          <h2 class="blue-text">{{ tosite()?.sum ?? tosite()?.summa | lmoney: 'EUR' | async }}</h2>
        </div>
      }
    </div>
  </div>

  <div class="nappula-container">
    <div class="nappulat">
      @if (tosite()?.einvoiceApprovalStatus === 'pending-approval') {
        <button mat-button class="primarybutton" (click)="approveInvoice(tosite())">{{ 'tositteet.laskujen-hyvaksyminen.hyvaksy' | translate | async }}</button>
      }
      @if (tosite()?.einvoiceApprovalStatus === 'pending-approval') {
        <button mat-button class="primarybutton" (click)="rejectInvoice(tosite())">{{ 'tositteet.laskujen-hyvaksyminen.hylkaa' | translate | async }}</button>
      }

      @if (!tosite()?.x) {
        <button mat-button class="secondarybutton" (click)="lataaKuitti()">{{ 'kuitit.katsele.lataa' | translate | async }}</button>
      }
      <button mat-button class="secondarybutton" (click)="muokkaa()">{{ 'yleiset.muokkaa' | translate | async }}</button>

      @if (!tosite()?.x && tosite()?.type !== 'einvoice') {
        <button mat-button class="secondarybutton" (click)="poista()">{{ 'kuitit.katsele.poista' | translate | async }}</button>
      }
    </div>
  </div>

  @if (!!einvoiceApprovals().length) {
    <div class="dark-gray-text" style="margin-bottom: 20px">
      <div>{{ 'tositteet.laskujen-hyvaksyminen.verkkolaskun-hyvaksynyt' | translate | async }}:</div>
      @for (approval of einvoiceApprovals(); track approval) {
        <div style="padding-left: 20px">
          {{ approval }}
        </div>
      }
    </div>
  }

  @if (tosite()?.x && tosite()?.w) {
    <div class="dark-gray-text" style="padding-bottom: 15px">{{ tosite().w }}</div>
  }
  @if ((!tosite()?.x || !tosite()?.w) && (tosite()?.el || tosite()?.seller)) {
    <div class="el-kommentti">{{ tosite().el || tosite().seller }}</div>
  }
  <div>{{ tosite()?.selite }}</div>
  @if (tosite()?.x && tosite()?.m) {
    <div class="selv-kommentti">{{ tosite().m }}</div>
  }
  @if (tosite().userApiMessage) {
    <div class="tosite-api-msg">{{ tosite().userApiMessage }}</div>
  }

  @if (projektiNimiObservable() | async; as projektiNimi) {
    <div class="tosite-api-msg">{{ projektiNimi }}</div>
  }

  @if ($safeNavigationMigration(tosite()?.alvVahennysoikeus) !== null) {
    <div>{{ 'kuitit.katsele.alv' | translate | async }} {{ tosite()?.alvVahennysoikeus }} %</div>
  }

  <!-- <div *ngIf="alkuperaiset" class="alkuperaiset-container">
<div *ngFor="let alkuperainen of alkuperaiset">
  {{alkuperainen.nimi}}
  <button mat-button class="secondarybutton" (click)="lataaAlkuperainen(alkuperainen)">
    <span>Lataa tiedosto</span>
  </button>
</div>
</div> -->

  <div class="tosite-sivut">
    @for (kuvat of ryhmitetytKuvat(); track $index) {
      @if (kuvat.length > VIRTUAL_SCROLL_THRESHOLD) {
        <cdk-virtual-scroll-viewport class="tosite-sivut-viewport" [itemSize]="sivunKorkeus" minBufferPx="1200" maxBufferPx="2400">
          <div *cdkVirtualFor="let kuva of kuvat" class="tosite-sivu" [style.height.px]="sivunKorkeus">
            <div app-tosite-kuva [url]="kuva" class="mat-elevation-z4 tosite-sivu-kuva"></div>
          </div>
        </cdk-virtual-scroll-viewport>
      } @else {
        @for (kuva of kuvat; track kuva) {
          <div>
            <div app-tosite-kuva [url]="kuva" class="mat-elevation-z4" style="width: 100%; min-height: 100px; margin-top: 15px; overflow-y: hidden; position: relative; border-radius: 2px"></div>
          </div>
        }
      }
    }
  </div>
</div>
